import React, { useState, useEffect, useContext } from "react";

import SurveyQuality from "./SurveyQuality/SurveyQuality";
import SpamDetection from "./SpamDetection/SpamDetection";
import UserBlackList from "./UserBlackList/UserBlackList";
import Utility from "./Utility/Utility";
import { AuthContext } from "@/auth/AuthContext";

const PanelistQuality = () => {
  const [activeComponent, setActiveComponent] = useState(localStorage.getItem('PanelistQuality') || "User Black List");
  const { user } = useContext(AuthContext);
  const [editable, setEditable] = useState(null);

  useEffect(() => {
    if (user?.roleId == 1 || user?.roleId == 2) {
      setEditable(true)
    }
  }, [user])

  // Array with tab names and corresponding components
  const tabs = [

    { name: "User Black List", component: <UserBlackList editable={editable} /> },
    { name: "Survey Quality", component: <SurveyQuality editable={editable} /> },
    { name: "Spam Detection", component: <SpamDetection editable={editable} /> },
    { name: "Utility", component: <Utility editable={editable} /> },
  ];

  // Find the active tab and its component
  const renderComponent = () => {
    const activeTab = tabs.find(tab => tab.name === activeComponent);
    return activeTab ? activeTab.component : null;
  };

  const changeActiveComponent = (name) => {
    setActiveComponent(name)
    localStorage.setItem('PanelistQuality', name);
  }

  return (
    <div className="min-h-screen flex flex-col items-center p-6 pt-14">
      <div style={{ zIndex: 10 }} className="flex flex-col justify-center items-center w-full sticky top-14 bg-[var(--bgColor)]">
        <h1 className="text-xl m-4 font-semibold">Panelist Quality</h1>
        <div className="flex gap-2 max-w-100 flex-wrap mb-2">
          {tabs.map(({ name }) => (
            <button
              key={name}
              className={`p-2 rounded-lg text-sm border-b-2 min-w-[100px] ${activeComponent === name
                  ? "activeBtn text-white"
                  : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
                }`}
              onClick={() => { changeActiveComponent(name) }}
            >
              {name}
            </button>
          ))}
        </div>
      </div>

      {renderComponent()}
    </div>
  );
};

export default PanelistQuality;
